import attribution from "./js/plugins/attributionPlugin";
import layermenu from "./js/plugins/layermenuPlugin";
import searchPlugin from "./js/plugins/searchPlugin";
import topMenuPlugin from "./js/plugins/topMenuToolsPlugin";
import mapTools from "./js/plugins/mapToolPlugin.js";
import contextPlugin from "./js/plugins/contextMenuPlugin.js";
import baselayerSwitcher from "./js/plugins/baselayerSwitcherPlugin";

("use strict");
var parameters, configs;
//var baseUrl = "//10.192.10.26/";
var baseUrl = "https://od2.pbe.oslo.kommune.no/";
var extraUrl = "//10.192.10.26/";
((parameters = {
  wfsTillegg: "&version=1.1.0&service=wfs&request=GetFeature",
  /** Kart-url'er */
  cacheurl: baseUrl + "tilecache",
  phpAutocomplete: "https://od2.pbe.oslo.kommune.no:9443/",
  autocompleteUrl: "https://od2.pbe.oslo.kommune.no:9443/getAutocompleteData",
  searchUrl: baseUrl + "cgi-bin/wms?map=WFS_SOK",
  kartinnsynurl: baseUrl + "cgi-bin/wms?map=KARTINNSYN",
  geoJsonWFS: baseUrl + "cgi-bin/wms?map=PI4_GEOJSON",
  tableWfs: baseUrl + "cgi-bin/wms?map=EIENDOM_TABELL&tabell=",
  mapcacheurl: baseUrl + "mapcache/wmts?",
  ki_forgrunnurl: baseUrl + "cgi-bin/wms?map=FORGRUNN",
  flyfotoUrl: baseUrl + "/cgi-bin/wms?map=FLYFOTO",
  flyfotoTextUrl: baseUrl + "cgi-bin/wms?map=TEKST_FLYFOTO",
  bakgrunnGraaUrl: baseUrl + "cgi-bin/wms?map=BAKGRUNN",
  apningUrl: baseUrl + "cgi-bin/wms?map=AAPNING",
}),
  (configs = {
    minZoom: 11,
    mapTools: [
      //Zoom helt ut
      {
        id: "zoom-full-small",
        className: "map-eraser-btn",
        toolTip: "Zoom til hele Oslo",
        buttonText: "Zoom helt ut",
        iconType: "icon",
        icon: "glyphicon glyphicon-globe",
        onclick: "zoomFullClick",
      },
      //Måle lengde
      {
        id: "measure-length-small",
        className: "length-btn measure-btn",
        toolTip: "Mål avstand",
        buttonText: "Mål avstand",
        iconType: "icon",
        icon: "icon-measure",
        onclick: "measureLengthClick",
        register: function (registerFunction, callback) {
          mapTools.registerLengthMeasurePlugin(registerFunction, callback);
        },
        toolHelp: {
          header: "Slik måler du",
          id: "measure-length-small-tool-help",
          steps: [
            "Klikk i kartet for plassere punktene du skal måle mellom.",
            "Dobbelklikk når du plasserer siste punkt for å fullføre en måling.",
            'Slett målingene når du er ferdig. Bruk knappen "Fjern markeringer i kartet" <i class = "glyphicon glyphicon-erase" aria-label="Fjern markeringer i kartet"></i>',
          ],
        },
      },
      {
        id: "map-eraser-small",
        className: "map-eraser-btn",
        toolTip: "Fjern markeringer av eiendommer og planer i kartet",
        buttonText: "Fjern markeringer",
        iconType: "icon",
        icon: "glyphicon glyphicon-erase",
        onclick: "eraserClick",
      },
    ],
    topMenu: [],
    baseLayers: [
      {
        olType: "group",
        layerId: "baselayers",
        displayInLayerMenu: false,
        layers: [
          {
            olType: "wmts",
            title: "Bakgrunnskart",
            layerId: "bakgrunn",
            url: parameters.mapcacheurl,
            layerName: "bakgrunn_graa",
            visible: false,
            dependent: "text1",
            displayInLayerMenu: false,
            altSource: {
              url: parameters.bakgrunnGraaUrl,
              layerName: "bakgrunn_graa",
            },
          },
          {
            olType: "wmts",
            layerId: "flyfoto",
            title: "Flyfoto",
            url: parameters.mapcacheurl + "map=FLYFOTO",
            layerName: "flyfoto",
            dependent: "text2",
            altSource: {
              url: parameters.flyfotoUrl,
              layerName: "nyeste_flyfoto_bg_hvit",
              epsg: "EPSG:32632",
            },
            displayInLayerMenu: false,
            visible: false,
          },
          {
            olType: "image",
            title: "Gatenavn, adresser, m.m (flyfoto)",
            layerId: "text2",
            url: parameters.flyfotoTextUrl,
            layerName: "forgrunn_tekst",
            zIndex: 100,
            displayInLayerMenu: false,
            visible: false,
          },
          {
            olType: "image",
            title: "Tiltaksflater",
            layerId: "tiltaksflate",
            url: parameters.ki_forgrunnurl,
            zIndex: 200,
            layerName: "Tiltaksflate",
            displayInLayerMenu: false,
            noToggle: true,
            visible: true,
          },
        ],
      },
    ],
    layermenuLayers: [
      {
        olType: "group",
        layerId: "apningstider",
        title: "Åpningstider",
        collapsible: true,
        groupCheckbox: false,
        layers: [
          {
            olType: "image",
            title: "Stengetid inne/ute",
            layerId: "stengetidDagens",
            url: parameters.apningUrl,
            layerName:
              "Åpningstider_linje_bydeler,Åpningstider_linje_sentrum,Åpningstider_flate",
            noToggle: true,
            visible: false,
            layerInfo: true,
            attribution: "©NAE",
            customLayerInfo:
              "<h3>Åpningstider</h3><br /><p>Bystyret i Oslo har vedtatt de overordnede rammene for åpningstider i åpningstidsforskift for Oslo kommune. I tillegg har 6 bydeler vedtatt egne lokale åpningstidsforskrifter. Områdene er markert med ulike farger i kartet.</p><p>Her er lenker til forskriftene:</p><ul><li><a href='https://lovdata.no/dokument/LF/forskrift/2025-04-30-752' target='_blank'>Åpningstidsforskrift for Oslo kommune</a></li><li><a href='https://lovdata.no/dokument/LF/forskrift/2018-09-13-1644?q=bydel%20gr%C3%BCnerl%C3%B8kka' target='_blank'>Bydel Grünerløkka</a></li><li><a href='https://lovdata.no/dokument/LF/forskrift/2022-05-05-810' target='_blank'>Bydel Gamle Oslo</a></li><li><a href='https://lovdata.no/dokument/LF/forskrift/2018-11-15-1720?q=ullern' target='_blank'>Bydel Ullern</a></li><li><a href='https://lovdata.no/dokument/LF/forskrift/2025-10-21-2119?q=bydel%20frogner' target='_blank'>Bydel Frogner</a></li><li><a href='https://lovdata.no/dokument/LF/forskrift/2020-02-11-3406?q=St.%20hanshaugen' target='_blank'>Bydel St. Hanshaugen</a></li><li><a href='https://lovdata.no/dokument/LF/forskrift/2024-09-12-2279/' target='_blank'>Bydel Nordre Aker</a></li></ul>",
            legend:
              parameters.apningUrl +
              "&SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=Tegnforklaring&FORMAT=image/png&STYLE=default&SLD_VERSION=1.1.0",
          },
          {
            olType: "cluster",
            title: "Skjenkebevillinger",
            layerId: "skjenkebevillingPunkt",
            layerName: "Skjenkebevilling_punkt",
            url: parameters.apningUrl + parameters.wfsTillegg,
            typeName: "Skjenkebevilling_punkt",
            featureInfo: true,
            fillColor: "#8d50b1",
            textColor: "white",
            layerInfo: true,
            customLayerInfo:
              "<h3>Skjenkebevillinger</h3><br /><p>Kartet viser alle steder som har skjenkebevilling i Oslo og hvor lenge de kan holde åpent.</p><p>Hvert skjenkested vises som et punkt. Trykk på punktet for å se: <ul><li>Navn</li><li>Eier</li><li>Tillatte åpningstider</li><li>Om de har uteservering</li></ul><p>Merk: Faktiske åpningstider på stedene kan variere fra de tillatte tidene.</p></p>",
            visible: true,
            attribution: "©NAE",
            default: true,
          },
        ],
      },
      {
        olType: "group",
        layerId: "kartdetaljer",
        title: "Detaljer",
        collapsible: true,
        groupCheckbox: false,
        altTarget: "fkb",
        layers: [
          {
            olType: "wmts",
            title: "Bygninger, veier, koter m.m.",
            layerId: "situasjon",
            url: parameters.mapcacheurl,
            layerName: "bakgrunn_linjer",
            altSource: {
              url: parameters.ki_forgrunnurl,
              layerName: "Forgrunn",
              epsg: "EPSG:32632",
            },
            noToggle: true,
            visible: true,
          },
          {
            olType: "image",
            title: "Gatenavn, adresser, m.m.",
            layerId: "text1",
            url: parameters.ki_forgrunnurl,
            layerName: "forgrunn_tekst",
            zIndex: 100,
            conditional: { condition: "flyfoto", trigger: "text2" },
            noToggle: true,
            visible: true,
          },
          {
            olType: "group",
            layerId: "eiendomsgrenser",
            title: "Eiendomsgrenser",
            collapsible: true,
            layerInfo: true,
            customLayerInfo:
              "<h3>Eiendomsgrenser</h3><br /><h4>Tegnforklaring:</h4><div class='legend-row'><div class='legend-symb legend-symb-line legend-eiendomsgrenser-landmaalt'>&nbsp;</div><div class='legend-text'>Landmålt grense</div></div><div class='legend-row'><div class='legend-symb legend-symb-line legend-seksjonsgrense'>&nbsp;</div><div class='legend-text'>Seksjonsgrense</div></div><div class='legend-row'><div class='legend-symb legend-anleggseiendommer'>&nbsp;</div><div class='legend-text'>Anleggseiendom</div></div><div class='legend-row'><div class='legend-symb legend-symb-line legend-eiendomsgrenser-usikker'>&nbsp;</div><div class='legend-text'>Ikke landmålt/usikker grense</div></div>",
            groupCheckbox: true,
            visible: false,
            layers: [
              {
                olType: "wmts",
                title: "Eiendomsgrenser",
                layerId: "eiendom",
                layerInfo: false,
                url: parameters.mapcacheurl,
                layerName: "eiendom",
                altSource: {
                  url: parameters.kartinnsynurl,
                  layerName: "Eiendom_piv5",
                  epsg: "EPSG:32632",
                },
                visible: false,
              },
              {
                olType: "image",
                layerId: "eiendomText",
                title: "eiendomsText",
                url: parameters.kartinnsynurl,
                layerName: [
                  "Fkb_eiendom_tekst_piv5",
                  "Fkb_eiendom_informasjonspil_piv5",
                ],
                zIndex: 100,
                dependent: "eiendom",
                displayInLayerMenu: false,
                visible: false,
              },
              {
                olType: "image",
                title: "Anleggseiendommer",
                layerId: "Anleggseiendom",
                layerInfo: false,
                url: parameters.kartinnsynurl,
                layerName: "Anleggseiendom",
                altSource: {
                  url: parameters.kartinnsynurl,
                  layerName: "Eiendom_piv5",
                  epsg: "EPSG:32632",
                },
                visible: false,
              },
            ],
          },
          {
            olType: "image",
            title: "Bydel",
            layerId: "bydel",
            url: parameters.kartinnsynurl,
            layerName: "Bydelsgrenser",
            visible: true,
          },
        ],
      },
      {
        olType: "text",
        text: "<h3>Om tjenesten</h3> <p>Næringsetaten forsøker å gi så korrekte</br> data som mulig,  men det kan forekomme feil </br>eller mangler. </br>Det følger ingen rettsvirkninger av dette kartet. </p> <p>Dette er en tjeneste laget av </br>Plan- og bygningsetaten for Næringsetaten. </p> <p>Henvendelser om kartet sendes til </br>Næringsetaten.</p>",
      },
    ],
    fkbLayers: false,
    modes: [],
    search: {
      autocompleteUrl: parameters.autocompleteUrl,
      autocompleteHandlers: [
        { key: "gate", func: "lookupAdresserForGate" },
        { key: "plan", func: "getLookupPlan" },
        { key: "stedsnavn", func: "getLookupStedsnavn" },
      ],
      ariaLabel:
        "Skriv inn adresse, gårds- og bruksnummer, plannummer eller saksnummer",
      placeholder: "Søk på adresse",
    },
    mapInteractions: {
      featureHover: true,
      featureClick: true,
    },
    contextMenu: {
      disableMapClick: true,
      active: false,
      title1: "Om valgt eiendom",
      title2: "Om valgt punkt",
      mode: {
        top: true,
        area: false,
        point: false,
        /*bottom: "Hva vil du gjøre?",*/
      },
      headerField: {},
      bottomField: {},
      //Felter til kontekstmenyen.
      fields: [],
      //Layout og innlasting av data til kontekstmeny.
      //Targets id korresponderer med felter over.
      //Extendedinfo gir layout for nivå 2 ved klikk i menyen.
      loaders: [],
      dyplenker: [],
      //Layout for klikk på features i kartet.
      //Info kommer fra WFS
      featureClickLayout: {
        skjenkebevillingPunkt: {
          header: "Skjenkested",
          layout: [
            {
              type: "paragraph",
              prefix: "<strong>Navn</strong><br />",
              value: "OBJEKTNAVN",
            },
            {
              type: "paragraph",
              prefix: "<strong>Adresse</strong><br />",
              value: "ADRESSE",
            },
            {
              type: "paragraph",
              prefix: "<strong>Eier</strong><br />",
              value: "EIERNAVN",
            },
            {
              type: "paragraph",
              prefix: "<strong>Orgnummer</strong><br />",
              value: "ORGNR",
            },
            {
              type: "paragraph",
              prefix: "<strong>Åpent inne til klokken: </strong><br />",
              value: "INNE_TID",
            },
            {
              type: "paragraph",
              prefix: "<strong>Åpent ute til klokken: </strong><br />",
              value: "UTE_TID",
              alt: " ",
            },
          ],
        },
      },
      featureHoverLayout: {
        skjenkebevillingPunkt: {
          layout: [
            {
              type: "paragraph",
              prefix: "<strong>",
              value: "OBJEKTNAVN",
              postfix: "</strong>",
            },
          ],
        },
      },
    },
    //Tipsboks. TipId settes som cookie for å ikke vise boksen igjen.
    activeTip: false,
    tipText: "",
    tipId: "testWarning",
  }));

// Legg til ekstra css-filer
//$("head").append("<link rel='stylesheet' type='text/css' href='css/foo.css'>");

//Titlelink setter lenke for oslologo + planinnsyn. Går til seg selv hvis den ikke er satt.
export default {
  site: {
    title: " |&nbsp;&nbsp; Skjenkebevilling",
    titleLink: "",
  },
  loadplugins: function (map, callback) {
    attribution.initiate({
      parent: "footerId",
      id: "copy-pbe",
      text: "©Oslo PBE",
    });
    layermenu.initiate(configs.layermenuLayers, "Velg kartlag");
    searchPlugin.initiate(configs.search);
    contextPlugin.initiate(configs);
    topMenuPlugin.initiate(configs.topMenu, parameters.intranett);
    baselayerSwitcher.initiate(
      document.getElementById("mapmenu"),
      map,
      "bakgrunn",
      "flyfoto",
      "./img/bakgrunnskart.min.png",
      "./img/flyfoto.min.jpg",
    );
    callback();
  },
  customClickTriggers: [],
  parameters: parameters,
  configs: configs,
};
